import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, onMounted, Ref, ref } from 'vue';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import {
  BaseText,
  HeadingDisplay,
  DataTable,
  DataTableProps,
  ButtonContainer,
  ButtonPrimary,
  InputRange
} from '@warrenbrasil/nebraska-web';

import {
  IMarginAllocationPreviewV2,
  IMarginAllocationV2
} from '@/modules/trade/services/margin-allocation';

import {
  EMarginAllocationSteps,
  formattedData
} from '@/modules/trade/views/MarginAllocationV2/helpers';
import { moneyFormat } from '@/modules/common/helpers/currency';

interface IData {
  balance: { value: number; formatted: string };
  isUpdatingLimits: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DrawdownInput',
  setup(__props) {

const changeStep = inject('changeStep', (step: EMarginAllocationSteps) => ({
  step
}));
const updateDataForm = inject(
  'updateDataForm',
  (key: string, value: object) => ({
    key,
    value
  })
);

const dataForm = inject('dataForm') as Ref<IData>;
const marginAllocationPreview = inject(
  'marginAllocationPreview'
) as Ref<IMarginAllocationPreviewV2>;
const marginAllocation = inject('marginAllocation') as Ref<IMarginAllocationV2>;

const maximumDailyLossPercentage = ref(85);

const rangeValue = ref(maximumDailyLossPercentage.value);
const balanceValue = ref(0);
const balanceFormatted = ref('');

const drawdownData = computed(() => {
  const value = Math.floor((rangeValue.value / 100) * balanceValue.value);

  return {
    value,
    formatted: moneyFormat(value)
  };
});

const headingSubtitle = computed(() => {
  return `O valor foi automaticamente definido em ${maximumDailyLossPercentage.value}% do saldo alocado.`;
});

const tableData = computed(() => {
  return formattedData(
    marginAllocationPreview.value.variationTable,
    balanceValue.value,
    drawdownData.value.value
  );
});

const tableColumns = [
  {
    label: 'Ativo',
    align: DataTableProps.Align.Left,
    getter: 'ticker'
  },
  {
    label: 'Exposição máxima',
    align: DataTableProps.Align.Right,
    getter: 'maxExpose'
  }
];

const isDisabled = computed(() => {
  return rangeValue.value < marginAllocation.value.minimumDailyLossPercentage;
});

function nextStep() {
  updateDataForm('drawdown', {
    value: drawdownData.value.value,
    formatted: drawdownData.value.formatted
  });
  updateDataForm('drawdownPercentage', {
    value: rangeValue.value / 100,
    formatted: `${rangeValue.value}%`
  });

  changeStep(EMarginAllocationSteps.REVIEW);
}

onMounted(() => {
  balanceValue.value = dataForm.value.balance.value;
  balanceFormatted.value = dataForm.value.balance.formatted;
});

return { __sfc: true,changeStep, updateDataForm, dataForm, marginAllocationPreview, marginAllocation, maximumDailyLossPercentage, rangeValue, balanceValue, balanceFormatted, drawdownData, headingSubtitle, tableData, tableColumns, isDisabled, nextStep, NebraskaColors, BaseText, HeadingDisplay, DataTable, ButtonContainer, ButtonPrimary, InputRange }
}

})